import api from '../../../config/api';

const CalendarService = {
	async getCalendarEvents(ressourceId) {
		try {
			const res = await api
				.get(
					`${process.env.REACT_APP_API_ENDPOINT}api/calendars?resourceId=${ressourceId}`,
				)
				.then((response) => response)
				.catch((err) => ({
					status: err.response.status,
					data: null,
				}));

			return res;
		} catch (e) {
			return {
				status: 500,
				data: null,
			};
		}
	},

	async getSkills() {
		try {
			const res = await api
				.get(`${process.env.REACT_APP_API_ENDPOINT}api/skills`)
				.then((response) => response)
				.catch((err) => ({
					status: err.response.status,
					data: null,
				}));

			return res;
		} catch (e) {
			return {
				status: 500,
				data: null,
			};
		}
	},
	async getSectors() {
		try {
			const res = await api
				.get(`${process.env.REACT_APP_API_ENDPOINT}api/sectors`)
				.then((response) => response)
				.catch((err) => ({
					status: err.response.status,
					data: null,
				}));

			return res;
		} catch (e) {
			return {
				status: 500,
				data: null,
			};
		}
	},

	async getResources(params) {
		try {
			const res = await api
				.get(`${process.env.REACT_APP_API_ENDPOINT}api/intervenants`, {
					params,
				})
				.then((response) => response)
				.catch((err) => ({
					status: err.response.status,
					data: null,
				}));

			return res;
		} catch (e) {
			return {
				status: 500,
				data: null,
			};
		}
	},

	async deleteUnaivability(id) {
		try {
			const res = await api
				.delete(
					`${process.env.REACT_APP_API_ENDPOINT}api/unavaibility/${id}`,
					{},
				)
				.then((response) => response)
				.catch((err) => ({
					status: err.response.status,
					data: null,
				}));

			return res;
		} catch (e) {
			return {
				status: 500,
				data: null,
			};
		}
	},

	async addUnaivability(start, end, idRessource) {
		try {
			const data = {
				start,
				end,
				ressources: {
					id: idRessource,
				},
			};
			const res = await api
				.post(
					`${process.env.REACT_APP_API_ENDPOINT}api/unavailabilities`,
					data,
				)
				.then((response) => response)
				.catch((err) => ({
					status: err.response.status,
					data: null,
				}));

			return res;
		} catch (e) {
			return {
				status: 500,
				data: null,
			};
		}
	},

	async editPlanning(start, end, idRessource, weekType) {
		try {
			const data = {
				start,
				end,
				ressources: {
					id: idRessource,
				},
				weekType,
			};

			const res = await api
				.post(`${process.env.REACT_APP_API_ENDPOINT}api/shifts`, data)
				.then((response) => response)
				.catch((err) => ({
					status: err.response.status,
					data: null,
				}));

			return res;
		} catch (e) {
			return {
				status: 500,
				data: null,
			};
		}
	},

	async canUserEditPlanning(params) {
		try {
			const response = await api.get(
				`${process.env.REACT_APP_API_ENDPOINT}api/shifts/edit-permission`,
				{
					params,
				},
			);
			if (Array.isArray(response.data) && response.data.length > 0) {
				return response.data[0].success === true;
			}

			return false;
		} catch (e) {
			return false;
		}
	},
};

export default CalendarService;
